import React, { useEffect, useState, useMemo, useRef, use } from 'react';
import { useNavigate } from 'react-router-dom';
import 'chart.js/auto';
import { Bar } from 'react-chartjs-2';
import {
  FaPhone,
  FaCheckCircle,
  FaExclamationTriangle,
  FaTimesCircle
} from 'react-icons/fa';
import { list, listCampaignsApi, assignusers } from '../api/api';
import { listAssignableUsers } from '../api/users';
import { getAssignments, setAssignment } from '../common/assignments';
import { payloadFromToken } from '../api/auth';
import { useSessionStorage } from '../common/localStorage';
import { MultiSelect } from '../components/MultiSelect';
import { Formatter } from '../format';

const CampaignDashboard = ({ setAlert }) => {
  const navigate = useNavigate();
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCampaign, setSelectedCampaign] = useState('All');
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [selectedRating, setSelectedRating] = useState('all');
  const [campaigns, setCampaigns] = useState(['All']);
  const [temps, setTemps] = useState(['All']);
  const [selectedTemps, setSelectedTemps] = useState('All')
  const [campaignLoading, setCampaignLoading] = useState(true);
  const [assignmentsState, setAssignmentsState] = useState(getAssignments());
  const [users, setUsers] = useState([]);
  const [assignedFiles, setAssignedFiles] = useState([])
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [modalVis, setModalVis] = useState(false)
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState('')
  const selectAllRef = useRef(null)
  const [startKey, setStartKey] = useState('')
  const [tsmpFrom, setTsmpFrom] = useState('')
  const [campStartKey, setCampStartKey] = useState('')
  const [campAssigned, setcampAssigned] = useState('')
  const [allLoad, setAllLoad] = useState(true)
  const [campLoad, setCampLoad] = useState(true)
  const [jobs, setJobs] = useState(['All'])
  const [selectedJob, setSelectedJob] = useState('All')
  const [assessmentStatus, setAssessmentStatus] = useState('all')
  const [sortField, setSortField] = useState('timestamp');
  const [sortDirection, setSortDirection] = useState('desc');
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');
  const [dateFromInput, setDateFromInput] = useState('');
  const [dateToInput, setDateToInput] = useState('');

  const loadData = async (trig) => {
    setLoading(true);
    const dateParams = {};
    if (dateFrom) dateParams.dateFrom = String(new Date(`${dateFrom}T00:00:00`).getTime());
    if (dateTo) dateParams.dateTo = String(new Date(`${dateTo}T23:59:59.999`).getTime());
    try {
      if (selectedCampaign == "All"){
        if (startKey != '' && tsmpFrom != '' && trig) {
          const params = {
            count: window.pcaSettings?.api?.pageSize || 25,
            startKey: startKey,
            timestampFrom: tsmpFrom
          };

          // Add template filter alongside campaign
          if (selectedTemps !== 'All') {
            params.template = selectedTemps;
          }
          Object.assign(params, dateParams);
          const data = await list(params);
          const items = data.Records || data.Items || data;
          setStartKey(data.StartKey)
          setTsmpFrom(data.timestampFrom)
          const processedItems = items.map(call => {
            const compliance = call.Result?.Compliance;
            const score = call.Result?.QA_Score;
            
            let rating;
            if (call.Result?.Status === 'NoTranscript') {
              rating = 'notranscript';
            } else if (!compliance || (score < 40)) {
              rating = 'fail';
            } else if (compliance && (score >= 60)) {
              rating = 'pass';
            } else {
              rating = 'medium';
            }
            
            return { ...call, computedRating: rating };
          });
          setCalls(prev => [...prev, ...processedItems]);
        } else {
          const params = {
            count: window.pcaSettings?.api?.pageSize || 25
          };

          // Add template filter alongside campaign
          if (selectedTemps !== 'All') {
            params.template = selectedTemps;
          }
          Object.assign(params, dateParams);
          const data = await list(params);
          const items = data.Records || data.Items || data;
          setStartKey(data.StartKey)
          setTsmpFrom(data.timestampFrom) 
          const processedItems = items.map(call => {
            const compliance = call.Result?.Compliance;
            const score = call.Result?.QA_Score;
            
            let rating;
            if (call.Result?.Status === 'NoTranscript') {
              rating = 'notranscript';
            } else if (!compliance || (score < 40)) {
              rating = 'fail';
            } else if (compliance && (score >= 60)) {
              rating = 'pass';
            } else {
              rating = 'medium';
            }
            
            return { ...call, computedRating: rating };
          });
          setCalls(processedItems);                    
        }
        console.log("ALL Items : ", calls)
      }
      for (let i = 0; i <= campaigns.length -1; i++) {
       if (selectedCampaign == campaigns[i] && selectedCampaign != 'All') {
        // console.log("Listing for camp: ",campaigns[i] )
        if (campStartKey != '' && campAssigned != '', trig){
          const params = {
            count: window.pcaSettings?.api?.pageSize || 25,
            campaign: campaigns[i],
            startKey: campStartKey,
            campaignAssignedTo: campAssigned
          };

          // Add template filter alongside campaign
          if (selectedTemps !== 'All') {
            params.template = selectedTemps;
          }
          Object.assign(params, dateParams);
          const data = await list(params);
          setCampStartKey(data.StartKey)
          setcampAssigned(data.campaignAssignedTo)
          console.log("CAMP DATA ", data)
          const items = data.Records || data.Items || data;
          // setNextToken(data.NextToken)
          const processedItems = items.map(call => {
            const compliance = call.Result?.Compliance;
            const score = call.Result?.QA_Score;
            
            let rating;
            if (call.Result?.Status === 'NoTranscript') {
              rating = 'notranscript';
            } else if (!compliance || (score < 40)) {
              rating = 'fail';
            } else if (compliance && (score >= 60)) {
              rating = 'pass';
            } else {
              rating = 'medium';
            }
            
            return { ...call, computedRating: rating };
        });
        setCalls(prev => [...prev, ...processedItems]);
        } else {
          const params = {
            count: window.pcaSettings?.api?.pageSize || 25,
            campaign: campaigns[i]
          };

          // Add template filter alongside campaign
          if (selectedTemps !== 'All') {
            params.template = selectedTemps;
          }
          Object.assign(params, dateParams);
          const data = await list(params);
          setCampStartKey(data.StartKey)
          setcampAssigned(data.campaignAssignedTo)
          console.log("CAMP DATA ", data)
          const items = data.Records || data.Items || data;
          // setNextToken(data.NextToken)
          const processedItems = items.map(call => {
            const compliance = call.Result?.Compliance;
            const score = call.Result?.QA_Score;
            
            let rating;
            if (call.Result?.Status === 'NoTranscript') {
              rating = 'notranscript';
            } else if (!compliance || (score < 40)) {
              rating = 'fail';
            } else if (compliance && (score >= 60)) {
              rating = 'pass';
            } else {
              rating = 'medium';
            }
            
            return { ...call, computedRating: rating };
          });
          setCalls(processedItems);           
        }     
       }
      }
      

    } catch (err) {
      console.error('Failed to load calls', err);
      setAlert?.({
        variant: 'error',
        heading: 'Error',
        text: 'Failed to load calls.'
      });
    } finally {
      setLoading(false);
    }
  };const handleSort = (field) => {
    let newDirection = 'asc';
    if (sortField === field && sortDirection === 'asc') {
      newDirection = 'desc';
    }
    setSortField(field);
    setSortDirection(newDirection);
    setCurrentPage(1); // Reset to first page when sorting changes
  };
  console.log('CampAss: ', campAssigned)
  console.log('CampStart: ', campStartKey)

  const loadCampaigns = async () => {
    setCampaignLoading(true);
    try {
      const res = await listCampaignsApi();
      const tmps = (res.campaigns).map(c => [c.campaignName, c.templates]);
      const names = (res.campaigns || res).map(c => c.campaignName || c.name || c);
      setCampaigns(['All', ...names]);
      setTemps(['All', ...tmps])
    } catch (err) {
      console.error('Failed to load campaigns', err);
      setAlert?.({
        variant: 'error',
        heading: 'Error',
        text: 'Failed to load campaigns.'
      });
      const setVals = new Set(calls.map(c => c.customer));
      setCampaigns(['All', ...Array.from(setVals)]);
    } finally {
      setCampaignLoading(false);
    }
  };


  const handleAssign = (item, user) => {
    try {
      setAssignment(item.key || item.filename, user);
      setAssignmentsState(getAssignments());
    } catch (e) {
      console.error('Failed to assign agent', e);
      setAlert?.({
        variant: 'error',
        heading: 'Error',
        text: 'Failed to assign agent.'
      });
    }
  };

  useEffect(() => {
    loadData();
    loadCampaigns();
    listAssignableUsers()
      .then((data) => setUsers(data.users || data.Users || data))
      .catch(err => console.error('Failed to load assignable users', err));
  }, [selectedCampaign, selectedTemps, dateFrom, dateTo]);

  useEffect(() => {
    setSelectedTemps('All');
    setSelectedJob('All');
  }, [selectedCampaign]);

  useEffect(() => {
    setSelectedJob('All');
  }, [selectedTemps]);

  // Load jobs based on loaded calls for the selected campaign
  useEffect(() => {
    if (calls.length > 0 && selectedCampaign !== 'All') {
      // Filter calls by selected campaign and optionally template
      const filteredCalls = calls.filter(c => {
        const matchesCampaign = c.customer === selectedCampaign;
        const matchesTemplate = selectedTemps === 'All' || c.template === selectedTemps;
        return matchesCampaign && matchesTemplate;
      });

      // Get unique job IDs from filtered calls
      const uniqueJobIds = [...new Set(
        filteredCalls
          .map(c => c.jobId)
          .filter(Boolean)
      )];
      setJobs(['All', ...uniqueJobIds]);
    }
  }, [calls, selectedCampaign, selectedTemps]);

  useEffect(() => {
    if (!users.length || !calls.length) return;
    try {
      const token = window.localStorage.getItem('id_token');
      if (!token) return;
      const payload = payloadFromToken(token);
      const groups = payload['cognito:groups'];
      const username = payload['cognito:username'];
      const inGroup = Array.isArray(groups)
        ? groups.includes('QAAgent')
        : groups === 'QAAgent';
      if (!inGroup || !username) return;

      if (!users.find(u => (u.username || u.Username) === username)) {
        setUsers(prev => [...prev, { username }]);
      }

      calls.forEach(call => {
        const key = call.key || call.filename;
        if (!getAssignments()[key]) {
          setAssignment(key, username);
        }
      });
      setAssignedFiles([])
      setAssignmentsState(getAssignments());
    } catch (e) {
      console.error('Failed to set default assessor', e);
    }
  }, [users, calls]);

  useEffect(() => {
    const loadCheck = async () => {
      if (startKey == undefined && tsmpFrom == undefined){
        setAllLoad(false)
      }
      if (campAssigned == undefined && campStartKey == undefined){
        setCampLoad(false)
      }
    }
    loadCheck()
  }, [startKey, campAssigned, tsmpFrom, campStartKey])


  const agents = useMemo(() => {
    const filtered = selectedCampaign === 'All' ? calls : calls.filter(c => c.customer === selectedCampaign);
    const setVals = new Set(filtered.map(c => c.agent));
    return ['All', ...Array.from(setVals)];
  }, [calls, selectedCampaign]);

  const campaignCalls = useMemo(
    () =>
      selectedCampaign === 'All'
        ? calls
        : calls.filter(c => c.customer === selectedCampaign),
    [calls, selectedCampaign]
  );

  const campaignStats = useMemo(() => {
    const pass = campaignCalls.filter(c => c.computedRating === 'pass').length;
    const fail = campaignCalls.filter(c => c.computedRating === 'fail').length;
    const medium = campaignCalls.filter(c => c.computedRating === 'medium').length;
    const assessed = campaignCalls.filter(c => c.assessed === true).length;
    const outstanding = campaignCalls.length - assessed;
    return { pass, fail, medium, assessed, outstanding, total: campaignCalls.length };
  }, [campaignCalls]);
  
  const agentCalls = useMemo(() => {
    return campaignCalls.filter(c => {
      const r = (c.computedRating || '').toLowerCase();

      // Agent filter (OR logic for multiple agents)
      const matchesAgent = selectedAgents.length === 0 || selectedAgents.includes(c.agent);
      const matchesRating = selectedRating === 'all' || r === selectedRating;
      const matchesTemplate = selectedTemps === 'All' || c.template === selectedTemps;
      const matchesJob = selectedJob === 'All' || c.jobId === selectedJob;

      // Assessment status filter
      const matchesAssessment =
        assessmentStatus === 'all' ||
        (assessmentStatus === 'assessed' && c.assessed === true) ||
        (assessmentStatus === 'not-assessed' && c.assessed !== true);

      return matchesAgent && matchesRating && matchesTemplate && matchesJob && matchesAssessment;
    });
  }, [campaignCalls, selectedAgents, selectedRating, selectedTemps, selectedJob, assessmentStatus]);
  console.log("AGENT CALLS: ", agentCalls)

  const searchedCalls = useMemo(() => {
    if (!searchQuery) return agentCalls;
    // if (selectedTemps != 'All') {

    // }
    const q = searchQuery.toLowerCase();
    return agentCalls.filter(c =>
      (c.agent || '').toLowerCase().includes(q) ||
      (c.customer || '').toLowerCase().includes(q) ||
      (c.jobName || c.filename || '').toLowerCase().includes(q) ||
      (c.key || '').toLowerCase().includes(q) ||
      (c.template || '').toLowerCase().includes(q)
    );
  }, [agentCalls, searchQuery]);

  const sortedCalls = useMemo(() => {
    let sortableItems = [...searchedCalls];

    if (sortField) {
      sortableItems.sort((a, b) => {
        let aVal, bVal;

        // Map the sortField to the actual data properties
        switch (sortField) {
          case 'computedRating':
            aVal = a.computedRating;
            bVal = b.computedRating;
            break;
          case 'callName':
            aVal = a.guid || a.jobId || '';
            bVal = b.guid || b.jobId || '';
            break;
          case 'compliance':
            aVal = a.Result?.Compliance ? 1 : 0;
            bVal = b.Result?.Compliance ? 1 : 0;
            break;
          case 'qaScore':
            aVal = a.Result?.QA_Score ?? 0;
            bVal = b.Result?.QA_Score ?? 0;
            break;
          case 'assignedto':
            aVal = a.assignedto || 'Unassigned';
            bVal = b.assignedto || 'Unassigned';
            break;
          default:
            aVal = a[sortField];
            bVal = b[sortField];
        }

        // Handle timestamps explicitly
        if (sortField === 'timestamp') {
          aVal = new Date(aVal || 0).getTime();
          bVal = new Date(bVal || 0).getTime();
        }

        let primaryComparison = 0;

        // Compare numbers
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          primaryComparison = sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
        } else {
          // Compare strings/booleans
          if (typeof aVal === 'boolean') aVal = aVal ? 'true' : 'false';
          if (typeof bVal === 'boolean') bVal = bVal ? 'true' : 'false';

          aVal = String(aVal || '').toLowerCase();
          bVal = String(bVal || '').toLowerCase();

          primaryComparison = sortDirection === 'asc' 
            ? aVal.localeCompare(bVal) 
            : bVal.localeCompare(aVal);
        }

        // Secondary sort by timestamp if values are identical
        if (primaryComparison === 0 && sortField !== 'timestamp') {
          const aTime = new Date(a.timestamp || 0).getTime();
          const bTime = new Date(b.timestamp || 0).getTime();
          return bTime - aTime;
        }

        return primaryComparison;
      });
    }

    return sortableItems;
  }, [searchedCalls, sortField, sortDirection]);

  const paginatedCalls = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    return sortedCalls.slice(start, start + pageSize);
  }, [sortedCalls, currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchedCalls, pageSize]);

  const allFilteredIds = useMemo(
    () => searchedCalls.map(c => c.key || c.filename),
    [searchedCalls]
  );
  const allSelected =
    allFilteredIds.length > 0 &&
    allFilteredIds.every(id => assignedFiles.includes(id));

  useEffect(() => {
    if (selectAllRef.current) {
      selectAllRef.current.indeterminate =
        assignedFiles.length > 0 && !allSelected;
    }
  }, [assignedFiles, allSelected]);

  const stats = useMemo(() => {
     const pass = searchedCalls.filter(c => (c.computedRating || '').toLowerCase() === 'pass').length;
    const fail = searchedCalls.filter(c => (c.computedRating || '').toLowerCase() === 'fail').length;
    const medium = searchedCalls.filter(c => (c.computedRating || '').toLowerCase() === 'medium').length;
    const assessed = pass + fail + medium;
    return { pass, fail, medium, assessed, total: searchedCalls.length };
  }, [searchedCalls]);

  const barData = useMemo(
    () => ({
      labels: ['Pass', 'Medium', 'Fail'],
      datasets: [
        {
          label: '# of Calls',
          data: [campaignStats.pass, campaignStats.medium, campaignStats.fail],
          backgroundColor: ['#16a34a', '#eab308', '#dc2626']
        }
      ]
    }),
    [campaignStats]
  );

  const handleBarClick = (elems) => {
    if (elems.length > 0) {
      const idx = elems[0].index;
      const label = barData.labels[idx];
      setSelectedRating(label.toLowerCase());
    }
  };

  const totalCalls = calls.length;
  const totalCampaigns = campaigns.length - 1;

  if (loading || campaignLoading) {
    return <div className="text-center mt-20 text-gray-500">Loading...</div>;
  }
  // console.log("ASSIGNED FILES : ", assignedFiles)
  // console.log("ALL Users: ", users)
  // console.log("SELected Users: ", selectedUsers)

  const handleCheckboxChange = (key) => {
    setAssignedFiles(prev => {
      if (prev.includes(key)) {
        return prev.filter(item => item !== key);
      } else {
        return [...prev, key];
      }
    });
  };

  const toggleSelectAll = () => {
    if (allSelected) {
      setAssignedFiles([]);
    } else {
      setAssignedFiles(allFilteredIds);
    }
  };

const toggleUser = (user) => {
  setSelectedUsers((prev) => {
    const exists = prev.find((u) => u.email === user.email);
    if (exists) {
      return prev.filter((u) => u.email !== user.email);
    } else {
      return [...prev, user];
    }
  });
};


  const handleAssignSubmit = async () => {
    let body = {
      callIds: assignedFiles,
      agents: selectedUsers
    }
    let res = await assignusers(body)
    console.log(res)
    setModalVis(false)
  }

  console.log("SELECTED TEMPS: ", selectedTemps)

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Campaign Home</h1>
          <p className="text-gray-600 mt-1">
            Monitor campaign performance and manage quality assessments
          </p>
        </div>

        <div className="flex items-center space-x-3">
          <button
            onClick={() => navigate('/campaigns/new')}
            className="btn-outline"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
            </svg>
            New Campaign
          </button>

          <button
            onClick={() => navigate('/templates')}
            className="btn-primary"
          >
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            QA Scorecard
          </button>
        </div>
      </div>

      <div className="text-sm text-gray-500">
        {totalCampaigns} campaigns loaded | Total calls across all campaigns: {totalCalls}
      </div>

      {/* Row 1 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="card space-y-3">
          <h3 className="font-semibold">Select Campaign</h3>
          <select
            data-testid="campaign-filter"
            value={selectedCampaign}
            onChange={e => setSelectedCampaign(e.target.value)}
            className="select-field"
          >
            {campaigns.map(c => (
              <option key={c} value={c}>
                {c}
              </option>
            ))}
          </select>

          <h3 className="font-semibold">Filter by Date</h3>
          <div className="flex gap-2">
            <input
              type="date"
              data-testid="date-from-filter"
              value={dateFromInput}
              onChange={e => setDateFromInput(e.target.value)}
              className="input-field"
              aria-label="From date"
            />
            <input
              type="date"
              data-testid="date-to-filter"
              value={dateToInput}
              onChange={e => setDateToInput(e.target.value)}
              className="input-field"
              aria-label="To date"
            />
            <button
              data-testid="date-apply-filter"
              onClick={() => {
                setDateFrom(dateFromInput);
                setDateTo(dateToInput);
              }}
              disabled={dateFromInput === dateFrom && dateToInput === dateTo}
              className="btn-primary px-3 py-1 text-sm disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Apply
            </button>
          </div>
          <p className="text-xs text-gray-500">Pick dates then click Apply (filters by call timestamp / GSI1 sort key)</p>
          {selectedCampaign != 'All' && (
            <>
            <h3 className="font-semibold">Select Template</h3>
            <select
              data-testid="campaign-filter"
              value={selectedTemps}
              onChange={e => setSelectedTemps(e.target.value)}
              className="select-field"
            >
              <option value="All">ALL</option>
              {temps
                .find(entry => Array.isArray(entry) && entry[0] === selectedCampaign)?.[1]
                ?.map(template => (
                  <option key={template} value={template}>
                    {template}
                  </option>
                )) || []}
            </select>

            <h3 className="font-semibold">Select Job (Upload Batch)</h3>
            <select
              data-testid="job-filter"
              value={selectedJob}
              onChange={e => setSelectedJob(e.target.value)}
              className="select-field"
            >
              {jobs.map(j => (
                <option key={j} value={j}>
                  {j}
                </option>
              ))}
            </select>
            <p className="text-xs text-gray-500">Filter by upload batch</p>
            </>
          )}
        </div>

        <div className="card">
          <h3 className="font-semibold mb-1">Call Results Distribution</h3>
          <p className="text-sm text-gray-500 mb-2">Click on a bar to filter the table below</p>
          <Bar data={barData} options={{ onClick: (_e, els) => handleBarClick(els) }} />
        </div>
      </div>

      {/* Row 2 */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        <StatsCard
          testId="campaign-result"
          title="Result"
          value={`${campaignStats.pass}P / ${campaignStats.medium}M / ${campaignStats.fail}F`}
          subtitle="Pass / Medium / Fail"
          icon={<FaCheckCircle />}
          color="blue"
        />

        <StatsCard
          testId="campaign-volume"
          title="Volume"
          value={`${campaignStats.assessed} / ${campaignStats.outstanding}`}
          subtitle="Assessed / Outstanding"
          icon={<FaPhone />}
          color="yellow"
        />

        <StatsCard
          testId="campaign-pass-rate"
          title="Pass Rate"
          value={`${
            campaignStats.total
              ? Math.round((campaignStats.pass / campaignStats.total) * 100)
              : 0
          }%`}
          subtitle={`${campaignStats.pass} passing calls`}
          icon={<FaCheckCircle />}
          color="green"
        />

        <StatsCard
          testId="campaign-total"
          title="Total Calls"
          value={campaignStats.total}
          subtitle="All calls"
          icon={<FaPhone />}
          color="blue"
        />

        <StatsCard
          testId="campaign-failed"
          title="Failed Calls"
          value={campaignStats.fail}
          subtitle="Total failed"
          icon={<FaTimesCircle />}
          color="red"
        />
      </div>

      {/* Row 3 */}
      <div className="card space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <h3 className="font-semibold">Agent Performance</h3>
          <div className="flex gap-3 mt-2 sm:mt-0">
            <div className="w-64">
              <MultiSelect
                data-testid="agent-filter"
                options={agents.filter(a => a !== 'All').map(a => ({ value: a, label: a }))}
                value={selectedAgents}
                onChange={values => setSelectedAgents(values || [])}
                placeholder="Select agents..."
              />
            </div>
            <select
              data-testid="rating-filter"
              value={selectedRating}
              onChange={e => setSelectedRating(e.target.value)}
              className="select-field"
            >
              <option value="all">All Ratings</option>
              <option value="pass">Pass</option>
              <option value="fail">Fail</option>
              <option value="medium">Medium</option>
            </select>
            <select
              data-testid="assessment-filter"
              value={assessmentStatus}
              onChange={e => setAssessmentStatus(e.target.value)}
              className="select-field"
            >
              <option value="all">All Status</option>
              <option value="assessed">Assessed</option>
              <option value="not-assessed">Not Assessed</option>
            </select>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          <StatsCard
            testId="agent-total"
            title="Total Calls"
            value={stats.total}
            subtitle="Filtered calls"
            icon={<FaPhone />}
            color="blue"
          />
          <StatsCard
            testId="agent-pass-rate"
            title="Pass Rate"
            value={`${
              stats.total ? Math.round((stats.pass / stats.total) * 100) : 0
            }%`}
            subtitle={`${stats.pass} passing calls`}
            icon={<FaCheckCircle />}
            color="green"
          />
          <StatsCard
            testId="agent-failed"
            title="Failed Calls"
            value={stats.fail}
            subtitle="Total failed"
            icon={<FaTimesCircle />}
            color="red"
          />
        </div>
      </div>
      {modalVis && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white rounded shadow-lg w-full max-w-md p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Attach Files to Users</h2>
              <button
                onClick={() => setModalVis(false)}
                className="text-gray-500 hover:text-red-600 text-lg font-bold"
              >
                <b>X</b>
              </button>
            </div>

            <div className="mb-4 max-h-60 overflow-y-auto">
              {users.map((user) => (
                <label key={user.username} className="flex items-start gap-2 mb-2 cursor-pointer">
                  <input
                    type="checkbox"
                    data-testid={`assign-user-${user.username}`}
                    checked={selectedUsers.some((u) => u.email === user.email)}
                    onChange={() => toggleUser({email: user.email, name: user.username})}
                    className="mt-1"
                  />
                  <div>
                    <p className="font-medium">{user.username} <span className="text-sm text-gray-500">({user.email})</span></p>
                  </div>
                </label>
              ))}
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setModalVis(false)}
                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleAssignSubmit}
                className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded"
                data-testid="assign-confirm-btn"
              >
                Attach
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Active Filters */}
      {(selectedCampaign !== 'All' || selectedTemps !== 'All' || selectedJob !== 'All' || selectedAgents.length > 0 || selectedRating !== 'all' || assessmentStatus !== 'all' || dateFrom || dateTo) && (
        <div className="card">
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm font-semibold text-gray-700">Active Filters:</span>

            {selectedCampaign !== 'All' && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800">
                Campaign: {selectedCampaign}
                <button
                  onClick={() => setSelectedCampaign('All')}
                  className="ml-2 hover:text-blue-600"
                  aria-label="Remove campaign filter"
                >
                  ×
                </button>
              </span>
            )}

            {selectedTemps !== 'All' && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-purple-100 text-purple-800">
                Template: {selectedTemps}
                <button
                  onClick={() => setSelectedTemps('All')}
                  className="ml-2 hover:text-purple-600"
                  aria-label="Remove template filter"
                >
                  ×
                </button>
              </span>
            )}

            {selectedJob !== 'All' && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-indigo-100 text-indigo-800">
                Job: {selectedJob}
                <button
                  onClick={() => setSelectedJob('All')}
                  className="ml-2 hover:text-indigo-600"
                  aria-label="Remove job filter"
                >
                  ×
                </button>
              </span>
            )}

            {selectedAgents.map(agent => (
              <span key={agent} className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-cyan-100 text-cyan-800">
                Agent: {agent}
                <button
                  onClick={() => setSelectedAgents(prev => prev.filter(a => a !== agent))}
                  className="ml-2 hover:text-cyan-600"
                  aria-label={`Remove agent ${agent} filter`}
                >
                  ×
                </button>
              </span>
            ))}

            {selectedRating !== 'all' && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-yellow-100 text-yellow-800">
                Rating: {selectedRating.charAt(0).toUpperCase() + selectedRating.slice(1)}
                <button
                  onClick={() => setSelectedRating('all')}
                  className="ml-2 hover:text-yellow-600"
                  aria-label="Remove rating filter"
                >
                  ×
                </button>
              </span>
            )}

            {assessmentStatus !== 'all' && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-green-100 text-green-800">
                Status: {assessmentStatus === 'assessed' ? 'Assessed' : 'Not Assessed'}
                <button
                  onClick={() => setAssessmentStatus('all')}
                  className="ml-2 hover:text-green-600"
                  aria-label="Remove assessment status filter"
                >
                  ×
                </button>
              </span>
            )}

            {dateFrom && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-orange-100 text-orange-800">
                From: {dateFrom}
                <button
                  onClick={() => { setDateFrom(''); setDateFromInput(''); }}
                  className="ml-2 hover:text-orange-600"
                  aria-label="Remove date-from filter"
                >
                  ×
                </button>
              </span>
            )}

            {dateTo && (
              <span className="inline-flex items-center px-3 py-1 rounded-full text-sm bg-orange-100 text-orange-800">
                To: {dateTo}
                <button
                  onClick={() => { setDateTo(''); setDateToInput(''); }}
                  className="ml-2 hover:text-orange-600"
                  aria-label="Remove date-to filter"
                >
                  ×
                </button>
              </span>
            )}

            <button
              onClick={() => {
                setSelectedCampaign('All');
                setSelectedTemps('All');
                setSelectedJob('All');
                setSelectedAgents([]);
                setSelectedRating('all');
                setAssessmentStatus('all');
                setDateFrom('');
                setDateTo('');
                setDateFromInput('');
                setDateToInput('');
              }}
              className="ml-2 text-sm text-red-600 hover:text-red-800 hover:underline"
            >
              Clear All
            </button>
          </div>
        </div>
      )}

      <div className="card overflow-x-auto">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 mb-2 text-sm">
          <div className="flex items-center gap-2">
            {assignedFiles.length !== 0 && (
              <button
                data-testid="assign-selected-btn"
                onClick={() => setModalVis(true)}
                className="btn-primary px-3 py-1 whitespace-nowrap"
              >
                Assign QA Agent
              </button>
            )}
            <span>Selected Calls: {assignedFiles.length}</span>
          </div>
          <div className="flex items-center gap-2">
            <input
              type="text"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              placeholder="Search calls..."
              className="input-field w-full sm:w-64"
            />
            <span>
              Showing {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, searchedCalls.length)} of {searchedCalls.length} calls
            </span>
          </div>
        </div>
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-center">
                <input
                  type="checkbox"
                  ref={selectAllRef}
                  checked={allSelected}
                  onChange={toggleSelectAll}
                  className="h-4 w-4 text-cyan-600 border-gray-300 rounded"
                />
              </th>
              {[
                { id: 'computedRating', label: 'Rating' },
                { id: 'callName', label: 'Call Name' },
                { id: 'timestamp', label: 'Timestamp' },
                { id: 'conversationTime', label: 'Conversation Date' },
                { id: 'agent', label: 'Agent' },
                { id: 'conversationId', label: 'Conversation ID' },
                { id: 'dnis', label: 'DNIS' },
                { id: 'customer', label: 'Campaign' },
                { id: 'compliance', label: 'Compliance' },
                { id: 'qaScore', label: 'QA Score' },
                { id: 'duration', label: 'Duration' },
                { id: 'callerSentimentScore', label: 'Cust Sent' },
                { id: 'assessed', label: 'Assessed' },
                { id: 'assignedto', label: 'Assignee' }
              ].map((column) => (
                <th
                  key={column.id}
                  className="px-4 py-2 text-left text-xs font-semibold text-gray-700 uppercase cursor-pointer hover:bg-gray-100 transition-colors"
                  onClick={() => handleSort(column.id)}
                >
                  <div className="flex items-center space-x-1">
                    <span>{column.label}</span>
                    {sortField === column.id && (
                      <span className="text-cyan-600">
                        {sortDirection === 'asc' ? '↑' : '↓'}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {paginatedCalls.map((call, idx) => (
              <tr key={idx} className="group hover:bg-gray-50">
                <td className="px-4 py-2 text-center">
                  <input
                    type="checkbox"
                    value={call.key}
                    data-testid={`select-${call.key}`}
                    checked={assignedFiles.includes(call.key)}
                    onChange={() => handleCheckboxChange(call.key)}
                    className="h-4 w-4 text-cyan-600 border-gray-300 rounded"
                  />
                </td>
                <td className="px-4 py-2">
                  <span className={`status-badge status-${call.computedRating}`}>
                    {call.computedRating === 'notranscript'
                      ? 'No Transcript'
                      : call.computedRating.charAt(0).toUpperCase() + call.computedRating.slice(1)}
                  </span>
                </td>
                <td className="px-4 py-2 max-w-[250px]">
                  <div className="truncate">
                    <button
                      onClick={() =>
                        navigate(`/dashboard/${call.key || call.filename}`)
                      }
                      className="text-cyan-600 hover:underline w-full text-left"
                    >
                      {call.guid || call.jobId} - {Formatter.Timestamp(call.timestamp)}
                    </button>
                  </div>
                </td>
                <td className="px-4 py-2">{Formatter.Timestamp(call.timestamp)}</td>
                <td className="px-4 py-2">{Formatter.Timestamp(call.conversationTime) || ''}</td>
                <td className="px-4 py-2">{call.agent}</td>
                <td className="px-4 py-2 font-mono text-xs">{call.conversationId || '—'}</td>
                <td className="px-4 py-2 font-mono text-xs">{call.dnis || '—'}</td>
                <td className="px-4 py-2">{call.customer}</td>
                <td className="px-4 py-2">{call.Result?.Compliance ? "✅Pass" : "⚠️Fail"}</td>
                <td className="px-4 py-2">{call.Result?.QA_Score?? 0}</td>
                <td className="px-4 py-2">{call.duration}</td>
                <td className="px-4 py-2">
                  {call.callerSentimentScore !== undefined ? call.callerSentimentScore.toFixed(2) : 'N/A'}
                </td>
                <td className="px-4 py-2">
                  {call.assessed === true ? (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      ✓ Assessed
                    </span>
                  ) : (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                      Not Assessed
                    </span>
                  )}
                </td>
                <td className="px-4 py-2">
                  {call.assignedto == null && "Unassigned" }
                  {call.assignedto != null && call.assignedto}
                  {/* <select
                    data-testid={`assign-${call.key}`}
                    value={assignmentsState[call.key] || ''}
                    onChange={e => handleAssign(call, e.target.value)}
                    className="text-sm border border-gray-300 rounded px-2 py-1"
                  >
                    <option value="">Select</option>
                    {users.map(u => (
                      <option
                        key={u.username || u.Username}
                        value={u.username || u.Username}
                      >
                        {u.username || u.Username}
                      </option>
                    ))}
                  </select> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="bg-gray-50 px-4 py-3 flex items-center justify-between border-t border-gray-200 text-sm">
          <div className="flex items-center space-x-4">
            <span>
              Showing {(currentPage - 1) * pageSize + 1}–{Math.min(currentPage * pageSize, searchedCalls.length)} of {searchedCalls.length}
            </span>
            <select
              value={pageSize}
              onChange={(e) => setPageSize(Number(e.target.value))}
              className="select-field w-24"
            >
              {[10, 20, 50].map((size) => (
                <option key={size} value={size}>
                  {size} / page
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center space-x-2">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="btn-outline disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Prev
            </button>
            <div className="flex items-center space-x-1">
              {Array.from({ length: Math.min(5, Math.ceil(searchedCalls.length / pageSize)) }, (_, i) => {
                const total = Math.ceil(searchedCalls.length / pageSize);
                let pageNum;
                if (total <= 5) {
                  pageNum = i + 1;
                } else if (currentPage <= 3) {
                  pageNum = i + 1;
                } else if (currentPage >= total - 2) { 
                  pageNum = total - 4 + i;
                } else {
                  pageNum = currentPage - 2 + i;
                }
                return (
                  <button
                    key={pageNum}
                    onClick={() => setCurrentPage(pageNum)}
                    className={`px-3 py-1 rounded ${currentPage === pageNum ? 'bg-rewardsco-600 text-white' : 'hover:bg-gray-100'}`}
                  >
                    {pageNum}
                  </button>
                );
              })}
            </div>
            <button
              onClick={() => setCurrentPage(Math.min(Math.ceil(searchedCalls.length / pageSize), currentPage + 1))}
              disabled={currentPage === Math.ceil(searchedCalls.length / pageSize)}
              className="btn-outline disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        </div>
      </div>
      {(selectedCampaign == 'All' && allLoad) && (
        <button className="btn-secondary px-3 py-1 whitespace-nowrap" onClick={() => loadData(true)}>
          Load More Calls
        </button>        
      )}
      {(selectedCampaign != 'All' && campLoad) && (
        <button className="btn-secondary px-3 py-1 whitespace-nowrap" onClick={() => loadData(true)}>
          Load More {selectedCampaign} Calls
        </button>        
      )}

      <div className="text-xs text-green-600">Campaign statistics loaded</div>
    </div>
  );
};

// Simple stats card component reused from CampaignHomePage
const StatsCard = ({ title, value, subtitle, icon, color = 'blue', testId }) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    yellow: 'bg-yellow-50 text-yellow-600',
    red: 'bg-red-50 text-red-600'
  };

  return (
    <div
      className="card-hover transition transform hover:-translate-y-1"
      data-testid={testId}
    >
      <div className="flex items-center">
        <div
          className={`flex-shrink-0 w-12 h-12 ${colorClasses[color]} rounded-lg flex items-center justify-center text-2xl`}
        >
          {icon}
        </div>

        <div className="ml-4 flex-1">
          <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">
            {title}
          </p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
          {subtitle && <p className="text-xs text-gray-500 mt-1">{subtitle}</p>}
        </div>
      </div>
    </div>
  );
};

export default CampaignDashboard;